import { defineComponent, computed, toRef } from "vue";
import { V as VaMessageList } from "./VaMessageList/index-b2fc2774.mjs";
import { u as useValidationProps } from "../../../composables/useValidation-9a5317d9.mjs";
const _sfc_main = defineComponent({
  name: "VaMessageListWrapper",
  components: { VaMessageList },
  props: {
    ...useValidationProps
  },
  setup(props) {
    return {
      messagesColor: computed(() => {
        if (props.error) {
          return "danger";
        }
        if (props.success) {
          return "success";
        }
        return "";
      }),
      hasError: toRef(props, "error"),
      messagesComputed: computed(() => props.error ? props.errorMessages : props.messages),
      errorLimit: computed(() => props.error ? Number(props.errorCount) : 99)
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaMessageListWrapper.css';
//# sourceMappingURL=VaMessageListWrapper.vue_vue_type_script_lang-67f496f5.mjs.map
